import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldTypeTable = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.375 7.125H16.625M2.375 11.875H16.625M9.5 2.375V16.625M6.175 2.375H12.825C14.1551 2.375 14.8202 2.375 15.3282 2.63386C15.7751 2.86156 16.1384 3.22489 16.3661 3.67177C16.625 4.17981 16.625 4.84488 16.625 6.175V12.825C16.625 14.1551 16.625 14.8202 16.3661 15.3282C16.1384 15.7751 15.7751 16.1384 15.3282 16.3661C14.8202 16.625 14.1551 16.625 12.825 16.625H6.175C4.84488 16.625 4.17981 16.625 3.67177 16.3661C3.22489 16.1384 2.86156 15.7751 2.63386 15.3282C2.375 14.8202 2.375 14.1551 2.375 12.825V6.175C2.375 4.84488 2.375 4.17981 2.63386 3.67177C2.86156 3.22489 3.22489 2.86156 3.67177 2.63386C4.17981 2.375 4.84488 2.375 6.175 2.375Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFieldTypeTable;
